export default function validateEmail(values) {
    let errors = {};
    if (!values.email) {
        errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    	errors.email = "Email address is invalid";
    }
    
    return errors;
}